import type { OwnedItem, Wallet } from '@accra/shared';
import { api } from './apiClient';

const KEY = 'trotrorun.player.v1';

interface StoredPlayer {
  playerId: string;
  playerKey: string;
}

function load(): StoredPlayer | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as StoredPlayer) : null;
  } catch {
    return null;
  }
}

function store(player: StoredPlayer): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(player));
  } catch {
    // Storage blocked: this device gets a new player next time.
  }
}

/** The anonymous player for this device. Created on the server the first time. */
export async function ensurePlayer(): Promise<StoredPlayer | null> {
  const existing = load();
  if (existing) return existing;
  const created = await api<StoredPlayer>('POST', '/players', null, { platform: navigator.userAgent.slice(0, 40) });
  if (!created?.ok) return null;
  const player = { playerId: created.playerId, playerKey: created.playerKey };
  store(player);
  return player;
}

export interface Me {
  wallet: Wallet;
  owned: OwnedItem[];
  name: string | null;
}

export async function fetchMe(playerKey: string): Promise<Me | null> {
  const result = await api<{ wallet: Wallet; owned: OwnedItem[]; player: { name: string | null } }>('GET', '/players/me', playerKey);
  return result?.ok ? { wallet: result.wallet, owned: result.owned, name: result.player.name } : null;
}
